import React, { useState } from 'react';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  IconButton,
  Popper,
  Paper,
  MenuItem,
  ClickAwayListener,
  CircularProgress
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useLocation
import Breadcrumb from './Breadcrumb';
import SupportForm from './supportForm/supportForm';
import useApplicationData from '../hooks/useApplicationData';

function Header () {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const [anchorEl, setAnchorEl] = useState(null);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null); // For AccountCircleIcon Popover
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // For loader
  const {
    fetchApplicationData,
    fetchTotalApplicationsCount,
    fetchUniqueValues
  } = useApplicationData();

  const fetchApplicationDataOnClick = async () => {
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');

    await fetchTotalApplicationsCount(accessToken, refreshToken);
    await fetchUniqueValues(accessToken, refreshToken);
    await fetchApplicationData(accessToken, refreshToken);
  };

  const handlePopperOpen = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleNotificationPopperOpen = event => {
    setNotificationAnchorEl(notificationAnchorEl ? null : event.currentTarget);
  };

  const handleNotificationPopperClose = () => {
    setNotificationAnchorEl(null);
  };

  const handlePopperClose = () => {
    setAnchorEl(null);
  };

  const handleAccountPopoverOpen = event => {
    setAccountAnchorEl(accountAnchorEl ? null : event.currentTarget);
  };

  const handleAccountPopoverClose = () => {
    setAccountAnchorEl(null);
  };

  const handleLogout = () => {
    setIsLoading(true); // Show loader
    setTimeout(() => {
      // Clear localStorage and redirect after 1 second
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      setIsLoading(false);
      setAccountAnchorEl(null);
      navigate('/');
    }, 1000);
  };

  const handleAppetiteManagement = () => {
    navigate('/app/appetite');
    handlePopperClose();
  };
  const handleSupport = () => {
    setIsModalOpen(true);
    handlePopperClose();
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}'); // Fetch user details from localStorage

  return (
    <header className='bg-gray-100 py-2'>
      <div className='flex justify-between items-center mx-auto container'>
        {/* Logo Section */}
        <div
          className='flex items-center'
          onDoubleClick={fetchApplicationDataOnClick}
        >
          <img
            src='/img/logo.svg'
            alt='Nativeorange, LLC'
            className='h-16'
            onClick={() => navigate('/app/details')}
            style={{ width: '8rem', cursor: 'pointer' }}
          />
        </div>

        {/* Title Section */}
        <div className='text-orange-600 font-bold text-2xl product-title'>
          LexAI
        </div>

        <div className='flex items-center space-x-4 top-nav-icons'>
          {localStorage.getItem('refresh_token') && (
            <>
              <IconButton onClick={handleNotificationPopperOpen}>
                <NotificationsIcon style={{ color: '#FF8C00' }} />
              </IconButton>

              <IconButton onClick={handlePopperOpen}>
                <SettingsIcon style={{ color: '#FF8C00' }} />
              </IconButton>
              <IconButton onClick={handleAccountPopoverOpen}>
                <AccountCircleIcon style={{ color: '#FF8C00' }} />
              </IconButton>
            </>
          )}

          <Popper
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            placement='bottom-end'
            style={{ zIndex: 1300 }}
            className='appetite-popover'
          >
            <ClickAwayListener onClickAway={handlePopperClose}>
              <Paper>
                {/* <MenuItem onClick={handleAppetiteManagement}>
                  Appetite Management
                </MenuItem> */}
                <MenuItem onClick={handleSupport}>Help & Support</MenuItem>
              </Paper>
            </ClickAwayListener>
          </Popper>

          <Popper
            open={Boolean(accountAnchorEl)}
            anchorEl={accountAnchorEl}
            placement='bottom-end'
            className='appetite-popover'
            style={{ zIndex: 1300 }}
          >
            <ClickAwayListener onClickAway={handleAccountPopoverClose}>
              <Paper className='p-4 w-64 shadow-lg rounded-md'>
                <div className='flex flex-col items-start'>
                  <div className='text-gray-700 font-semibold text-lg mb-2'>
                    {user.name || 'Test User'}
                  </div>
                  {user.email && (
                    <div className='text-gray-500 text-sm mb-4'>
                      {user.email || 'No email available'}
                    </div>
                  )}
                  <MenuItem
                    onClick={handleLogout}
                    className='flex items-center justify-center w-full text-orange-600 font-medium'
                  >
                    {isLoading ? (
                      <CircularProgress
                        size={20}
                        className='text-orange-600 mr-2'
                      />
                    ) : (
                      'Logout'
                    )}
                  </MenuItem>
                </div>
              </Paper>
            </ClickAwayListener>
          </Popper>

          <Popper
            open={Boolean(notificationAnchorEl)}
            anchorEl={notificationAnchorEl}
            placement='bottom-end'
            className='appetite-popover'
            style={{ zIndex: 1300 }}
          >
            <ClickAwayListener onClickAway={handleNotificationPopperClose}>
              <Paper>
                <MenuItem>Notifications feature is coming soon!</MenuItem>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </div>
      </div>

      <div>
        {/* Banner for NativeOrange users */}
        <div
          style={{
            background: '#FFEDD5',
            color: '#EA580C',
            textAlign: 'center',
            fontWeight: 600,
            padding: '6px 0',
            fontSize: '1rem',
            letterSpacing: '0.5px'
          }}
        >
          This application is for testing purposes and intended only for
          NativeOrange users.
        </div>
      </div>

      {location.pathname !== '/' && (
        <div className='justify-between items-center mx-auto container'>
          <Breadcrumb />
        </div>
      )}
      {/* Support Form as a Modal */}
      <SupportForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </header>
  );
}

export default Header;
